import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SoLieuNhanh from "../components/SoLieuNhanh.jsx";

/**
 * /gioi-thieu: trả lời theo thứ tự dành cho ai, giúp được gì, vì sao có
 * website này, dữ liệu được xử lý thế nào, góp ý.
 *
 * Bản trực quan (18/10/2026): giữ nguyên nội dung chữ, thêm bốn hình:
 * dải số liệu thật, ba bước có chuyển động, so sánh trước và sau, sơ đồ
 * đường đi của dữ liệu. Chuyển động chỉ chạy khi khối hiện trên màn hình;
 * người bật "giảm chuyển động" và HTML prerender thấy trạng thái đứng yên đầy đủ.
 */
const LOI_ICH = [
  {
    ten: "Hiểu số liệu",
    moTa: "Tính thời gian còn đủ tiền hoạt động, số vốn cần gọi và tỷ lệ sở hữu theo giả định của chính bạn.",
    to: "/cong-cu",
    nhan: "Xem các công cụ",
    viDu: "Còn 11 tháng tiền",
    hinh: "so",
  },
  {
    ten: "Chọn việc tiếp theo",
    moTa: "Đi theo 5 trạm chuẩn bị, mỗi trạm là vài việc cụ thể kèm hướng dẫn và mẫu Excel.",
    to: "/lo-trinh",
    nhan: "Xem lộ trình",
    viDu: "Đang ở trạm 2/5",
    hinh: "tram",
  },
  {
    ten: "Lưu và tiếp tục",
    moTa: "Bấm lưu trong công cụ để tìm lại kết quả ở Bản chuẩn bị của tôi, rồi xuất hồ sơ một trang khi cần.",
    to: "/ban-chuan-bi",
    nhan: "Mở Bản chuẩn bị",
    viDu: "Hồ sơ một trang",
    hinh: "ho-so",
  },
];

const TRUOC = ["Blog tiếng Anh", "Bảng tính tự dựng", "Hỏi người quen", "Ví dụ ở nước ngoài", "Điều khoản khó hiểu"];
const SAU = [
  { ten: "Công cụ để tự tính", to: "/cong-cu" },
  { ten: "Bài viết có ví dụ số cụ thể", to: "/playbook" },
  { ten: "Nguồn vốn tại Việt Nam có ghi nguồn", to: "/nguon-von" },
];

const DUONG_DI = [
  { ten: "Bạn nhập số", phu: "Giả định của chính bạn" },
  { ten: "Trình duyệt tính", phu: "Phép tính chạy ngay trên máy bạn" },
  { ten: "Bạn chọn cách lưu", phu: "Hai lựa chọn bên dưới" },
];

/**
 * Bước đang sáng trong một khối có n bước. Trả về -1 khi chưa chạy (mọi bước
 * hiện đầy đủ), n khi đã xong hết. Chỉ chạy khi khối nằm trong màn hình.
 */
function useBuoc(n, ms = 1400) {
  const ref = useRef(null);
  const [buoc, setBuoc] = useState(-1);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    let hen;
    let dangChay = false;
    let k = 0;
    const chay = () => {
      if (!document.hidden) {
        setBuoc(Math.min(k, n));
        k = (k + 1) % (n + 3); // giữ trạng thái xong thêm hai nhịp rồi lặp
      }
      hen = setTimeout(chay, ms);
    };
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !dangChay) { dangChay = true; chay(); }
      else if (!e.isIntersecting && dangChay) { dangChay = false; clearTimeout(hen); }
    }, { threshold: 0.35 });
    io.observe(el);
    return () => { io.disconnect(); clearTimeout(hen); };
  }, [n, ms]);
  return [ref, buoc];
}

const trangThai = (i, buoc) => (buoc < 0 ? "" : i < buoc ? " xong" : i === buoc ? " dang" : " chua");

function HinhBuoc({ loai }) {
  if (loai === "so") {
    return (
      <svg viewBox="0 0 120 64" aria-hidden="true">
        <rect className="ab-h-vien" x="6" y="6" width="108" height="52" rx="8" />
        <rect className="ab-h-mo" x="16" y="38" width="10" height="12" rx="2" />
        <rect className="ab-h-mo" x="32" y="30" width="10" height="20" rx="2" />
        <rect className="ab-h-mo" x="48" y="24" width="10" height="26" rx="2" />
        <rect className="ab-h-muc ab-h-cot" x="64" y="16" width="10" height="34" rx="2" />
        <circle className="ab-h-la" cx="96" cy="28" r="9" />
        <path d="M91 28l3.5 3.5L101 25" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (loai === "tram") {
    return (
      <svg viewBox="0 0 120 64" aria-hidden="true">
        <path className="ab-h-duong" d="M14 46 C 34 46, 34 22, 54 22 S 78 42, 106 18" fill="none" />
        <circle className="ab-h-la" cx="14" cy="46" r="6" />
        <circle className="ab-h-muc ab-h-nhip" cx="38" cy="30" r="7" />
        <circle className="ab-h-mo" cx="60" cy="23" r="5" />
        <circle className="ab-h-mo" cx="82" cy="32" r="5" />
        <circle className="ab-h-mo" cx="106" cy="18" r="5" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 120 64" aria-hidden="true">
      <rect className="ab-h-vien" x="34" y="4" width="52" height="56" rx="6" />
      <rect className="ab-h-muc" x="42" y="13" width="26" height="5" rx="2" />
      <rect className="ab-h-mo" x="42" y="24" width="36" height="4" rx="2" />
      <rect className="ab-h-mo" x="42" y="32" width="30" height="4" rx="2" />
      <rect className="ab-h-mo" x="42" y="40" width="34" height="4" rx="2" />
      <circle className="ab-h-la ab-h-nhip" cx="84" cy="50" r="10" />
      <path d="M79 50l3.5 3.5L89 47" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function BaBuoc() {
  const [ref, buoc] = useBuoc(LOI_ICH.length, 1600);
  const phanTram = buoc < 0 ? 100 : Math.min(buoc, LOI_ICH.length - 1) / (LOI_ICH.length - 1) * 100;
  return (
    <div className="ab-ba-buoc" ref={ref}>
      <div className="ab-thanh" aria-hidden="true">
        <span style={{ width: `${phanTram}%` }} />
      </div>
      <ol className="ab-buoc-luoi">
        {LOI_ICH.map((x, i) => (
          <li key={x.ten} className={`ab-buoc${trangThai(i, buoc)}`}>
            <span className="ab-so" aria-hidden="true">{i + 1}</span>
            <div className="ab-buoc-hinh"><HinhBuoc loai={x.hinh} /></div>
            <h3>{x.ten}</h3>
            <p>{x.moTa}</p>
            <span className="ab-vi-du">Ví dụ: {x.viDu}</span>
            <Link to={x.to}>{x.nhan} →</Link>
          </li>
        ))}
      </ol>
    </div>
  );
}

function TruocSau() {
  const [ref, buoc] = useBuoc(SAU.length, 1300);
  return (
    <div className="ab-truoc-sau" ref={ref}>
      <div className="ab-cot ab-truoc">
        <p className="ab-nhan">Thường gặp</p>
        <div className="ab-manh">
          {TRUOC.map((x, i) => <span key={x} style={{ "--i": i }}>{x}</span>)}
        </div>
        <p className="ab-chu-nho">Tự ghép câu trả lời từ nhiều nơi, mỗi nơi một bối cảnh.</p>
      </div>
      <div className="ab-mui-ten" aria-hidden="true"><span>→</span></div>
      <div className="ab-cot ab-sau">
        <p className="ab-nhan">Trên fundraising.vn</p>
        <ul>
          {SAU.map((x, i) => (
            <li key={x.ten} className={trangThai(i, buoc).trim()}>
              <span className="ab-tick" aria-hidden="true">✓</span>
              <Link to={x.to}>{x.ten}</Link>
            </li>
          ))}
        </ul>
        <p className="ab-chu-nho">Một chỗ, bằng tiếng Việt, theo bối cảnh Việt Nam.</p>
      </div>
    </div>
  );
}

function DuongDiDuLieu() {
  const [ref, buoc] = useBuoc(DUONG_DI.length + 1, 1300);
  const reNhanh = buoc < 0 || buoc >= DUONG_DI.length;
  return (
    <figure className="ab-du-lieu" ref={ref}>
      <figcaption>Đường đi của số liệu bạn nhập</figcaption>
      <ol className="ab-dd-hang">
        {DUONG_DI.map((x, i) => (
          <li key={x.ten} className={`ab-dd-nut${trangThai(i, buoc)}`}>
            <b>{x.ten}</b>
            <span>{x.phu}</span>
          </li>
        ))}
      </ol>
      <div className={`ab-dd-nhanh${reNhanh ? " hien" : ""}`}>
        <div className="ab-dd-lua-chon">
          <span className="ab-dd-the">Mặc định</span>
          <b>Không đăng nhập</b>
          <span>Bản lưu chỉ nằm trên trình duyệt đang dùng.</span>
        </div>
        <div className="ab-dd-lua-chon">
          <span className="ab-dd-the tuy-chon">Tuỳ chọn</span>
          <b>Đăng nhập bằng email</b>
          <span>Đồng bộ Bản chuẩn bị giữa các thiết bị.</span>
        </div>
      </div>
    </figure>
  );
}

export default function About() {
  return (
    <div className="about about-v2 about-v3">
      <section className="about-dau">
        <p className="eyebrow">VỀ FUNDRAISING.VN</p>
        <h1>Hiểu số liệu. Biết bước tiếp theo khi chuẩn bị gọi vốn.</h1>
        <p className="lead">
          Fundraising.vn là công cụ, hướng dẫn và mẫu bằng tiếng Việt cho người
          sáng lập lần đầu chuẩn bị gọi vốn. Bạn có thể thử các phương án tài
          chính, rà soát hồ sơ và tìm hiểu nguồn vốn phù hợp, miễn phí và không
          cần tài khoản.
        </p>
        <ul className="ab-cam-ket" aria-label="Điều kiện sử dụng">
          <li>Miễn phí</li>
          <li>Không cần tài khoản</li>
          <li>Tiếng Việt, bối cảnh Việt Nam</li>
        </ul>
        <div className="hang-nut">
          <Link className="nut" to="/lo-trinh">Xem lộ trình chuẩn bị →</Link>
          <Link to="/cong-cu">Xem các công cụ</Link>
        </div>
      </section>

      <SoLieuNhanh className="ab-so-lieu" />

      <section className="about-phan" aria-labelledby="ab-lam-gi">
        <h2 id="ab-lam-gi">Bạn có thể làm gì ở đây?</h2>
        <p className="ab-dan">Ba việc nối tiếp nhau, làm đến đâu lưu đến đó.</p>
        <BaBuoc />
      </section>

      <section className="about-phan" aria-labelledby="ab-vi-sao">
        <h2 id="ab-vi-sao">Vì sao có website này?</h2>
        <p>
          Chia cổ phần thế nào, tiền còn đủ dùng bao lâu, cần chuẩn bị gì trước
          khi gặp nhà đầu tư? Người sáng lập lần đầu thường phải tự ghép câu trả
          lời từ nhiều nguồn, phần lớn bằng tiếng Anh và theo bối cảnh nước ngoài.
        </p>
        <TruocSau />
        <p>
          Fundraising.vn gom các câu hỏi đó về một chỗ: công cụ để tự tính, bài
          viết giải thích bằng ví dụ có số cụ thể, và danh mục nguồn vốn tại
          Việt Nam có ghi nguồn.
        </p>
      </section>

      <section className="about-phan" aria-labelledby="ab-du-lieu">
        <h2 id="ab-du-lieu">Thông tin và dữ liệu được xử lý thế nào?</h2>
        <h3>Dữ liệu bạn nhập</h3>
        <DuongDiDuLieu />
        <ul>
          <li>Các phép tính chạy ngay trên trình duyệt của bạn.</li>
          <li>
            Không đăng nhập: bản lưu chỉ nằm trên trình duyệt đang dùng. Xoá dữ
            liệu trình duyệt hoặc đổi máy có thể làm mất bản lưu.
          </li>
          <li>
            Đăng nhập bằng email là tuỳ chọn, chỉ để đồng bộ Bản chuẩn bị giữa
            các thiết bị: thông tin startup, kết quả đã lưu, kịch bản và nguồn
            vốn đã lưu.
          </li>
          <li>
            Sao lưu, khôi phục hoặc xoá dữ liệu ở{" "}
            <Link to="/ban-chuan-bi/tai-khoan">Bản chuẩn bị → Cài đặt &amp; dữ liệu</Link>.
            Chi tiết ở <Link to="/quyen-rieng-tu">Chính sách quyền riêng tư</Link>.
          </li>
        </ul>

        <h3>Thông tin nguồn vốn</h3>
        <div className="ab-nguon">
          <div className="ab-nguon-the" aria-hidden="true">
            <p className="ab-nguon-ten">Mỗi quỹ trong danh mục ghi</p>
            <dl>
              <div><dt>Nguồn</dt><dd>Trang chính thức</dd></div>
              <div><dt>Ngày kiểm chứng</dt><dd>Ghi trên từng quỹ</dd></div>
              <div><dt>Điều chưa công bố</dt><dd className="ab-chua">Chưa công bố</dd></div>
            </dl>
          </div>
          <p>
            Mỗi quỹ và chương trình ghi nguồn và ngày kiểm chứng. Thông tin đơn vị
            chưa công bố được ghi là “chưa công bố”, không suy đoán. Danh mục chưa
            đại diện toàn bộ thị trường; hãy xác nhận trên trang chính thức trước
            khi nộp hồ sơ.
          </p>
        </div>
        <details>
          <summary>Tôi nên hiểu điểm số như thế nào?</summary>
          <p>
            Điểm là kết quả đối chiếu theo tiêu chí và dữ liệu bạn nhập, không
            phải xác suất gọi vốn thành công. Kết quả chỉ để tự chuẩn bị, không
            thay thế tư vấn đầu tư hoặc pháp lý.
          </p>
        </details>
        <details>
          <summary>Website có đại diện cho quỹ không?</summary>
          <p>
            Việc xuất hiện trong danh mục không đồng nghĩa quỹ xác nhận, hợp tác
            hoặc ủy quyền cho Fundraising.vn.
          </p>
        </details>
      </section>

      <section className="about-phan about-gop-y" aria-labelledby="ab-gop-y">
        <h2 id="ab-gop-y">Góp ý hoặc báo lỗi</h2>
        <p>Gửi trang gặp vấn đề, mô tả ngắn và nguồn đối chiếu nếu có. Đừng gửi số liệu nhạy cảm của công ty.</p>
        <a className="nut phu" href="mailto:xin-chao@fundraising.vn?subject=G%C3%B3p%20%C3%BD%20fundraising.vn">
          Gửi góp ý qua email
        </a>
      </section>
    </div>
  );
}
